import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#simple-step-bar" }),
  /*#__PURE__*/_createTextVNode(" Simple step bar ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Simple step bars, where "),
  /*#__PURE__*/_createVNode("code", null, "align-center"),
  /*#__PURE__*/_createTextVNode(", "),
  /*#__PURE__*/_createVNode("code", null, "description"),
  /*#__PURE__*/_createTextVNode(", "),
  /*#__PURE__*/_createVNode("code", null, "direction"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createVNode("code", null, "space"),
  /*#__PURE__*/_createTextVNode(" will be ignored. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_steps, {
        space: 200,
        active: 1,
        simple: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_step, {
            title: "Step 1",
            icon: "el-icon-edit"
          }),
          _createVNode(_component_el_step, {
            title: "Step 2",
            icon: "el-icon-upload"
          }),
          _createVNode(_component_el_step, {
            title: "Step 3",
            icon: "el-icon-picture"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_steps, {
        active: 1,
        "finish-status": "success",
        simple: "",
        style: {"margin-top":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_step, { title: "Step 1" }),
          _createVNode(_component_el_step, { title: "Step 2" }),
          _createVNode(_component_el_step, { title: "Step 3" })
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code7), 1)
        ]),
        _: 1
      })
    ])
  ]))
}